import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import {MarketQuery} from '../lib/+state/market.selector';
import * as MarketActions from '../lib/+state/market.action';
import {MarketState} from '../lib/+state/market.reducer';

@Injectable({ providedIn: 'root' })
export class MainFacade {
    error$ = this.store.select(MarketQuery.getError);
    loading$ = this.store.select(MarketQuery.getLoading)
    user$ = this.store.select(MarketQuery.getUser);
    nfts$ = this.store.select(MarketQuery.getNfts);
    showNfts$ = this.store.select(MarketQuery.getShowNfts);
    login$ = this.store.select(MarketQuery.login);
    allMissions$ = this.store.select(MarketQuery.getAllMissions);
    myMissions$ = this.store.select(MarketQuery.getMyMissions);
    levels$ = this.store.select(MarketQuery.getLevels);
    filteredMissions$ = this.store.select(MarketQuery.getFilterMissions);
    filter$ = this.store.select(MarketQuery.getFilter);
    claim$ = this.store.select(MarketQuery.getClaim);
    inventory$ = this.store.select(MarketQuery.getInventory);
    myInventory$ = this.store.select(MarketQuery.getMyInventory);
    scores$ = this.store.select(MarketQuery.getScores);
    allSkills$ = this.store.select(MarketQuery.getAllSkills)
    pastSeason$ = this.store.select(MarketQuery.getPastSeason)
    season$ = this.store.select(MarketQuery.getSeason);
    onMissions$ = this.store.select(MarketQuery.getOnMissions)
    claimable$ = this.store.select(MarketQuery.getClaimable);
    selectDetails$ = this.store.select(MarketQuery.getSelectDetails);
    selectPack$ = this.store.select(MarketQuery.getSelectPack)
    pass$ = this.store.select(MarketQuery.getPass);
    passrewards$ = this.store.select(MarketQuery.getPassRewards);
    userSeasonrewards$ = this.store.select(MarketQuery.getUserSeasonRewards);
    eth$ = this.store.select(MarketQuery.getEth);
    packSigs$ = this.store.select(MarketQuery.getPackSigs);
    packs$ = this.store.select(MarketQuery.getPacks);
    cards$ = this.store.select(MarketQuery.getCards);
    opened$ = this.store.select(MarketQuery.getOpened);
    approval$ = this.store.select(MarketQuery.getApproval);
    showProfileEdit$ = this.store.select(MarketQuery.getShowProfileEdit);
    userScore$ = this.store.select(MarketQuery.getUserScore);
    upgrade$ = this.store.select(MarketQuery.getUpgrade);
    allSell$ = this.store.select(MarketQuery.getAllSell);
    userSell$ = this.store.select(MarketQuery.getUserSell);
    modal$ = this.store.select(MarketQuery.getModal);
    shareprofile$ = this.store.select(MarketQuery.getShareprofile);
    mobileMenu$ = this.store.select(MarketQuery.getMobileMenu);
    constructor(private store: Store<MarketState>) {}

    login(provider:string){
        this.store.dispatch(MarketActions.login({provider:provider}));
    }

    logout(){
        this.store.dispatch(MarketActions.logout({data:null}));
    }

    setShowProfileEdit(data){
        this.store.dispatch(MarketActions.showProfileEdit({data:data}));
    }

    getUser(address:string){
        this.store.dispatch(MarketActions.getUser({address:address}))
    }

    updateAvatar(id:any, url:any, address:any, username:any){
        this.store.dispatch(MarketActions.updateAvatar({id:id, url:url, address:address, username:username}));
    }

    getAllMissions(){
        this.store.dispatch(MarketActions.getAllMissions({data:null}));
    }

    getMobileMenu(val){
        this.store.dispatch(MarketActions.mobileMenu({data:val}));
    }

    getMyMissions(userId:any){
        this.store.dispatch(MarketActions.getMyMissions({userId:userId}));
    }

    deploy(userId:any, soldier:any[], item:any){
        this.store.dispatch(MarketActions.deployToMission({userId:userId,soldier:soldier, items:item}));
    }

    closeModal(){
        this.store.dispatch(MarketActions.closeModal({data:null}));
    }

    desert(userId:any, missionId:any){
        this.store.dispatch(MarketActions.desertMission({userId:userId,mission:missionId}));
    }

    claim(userId:any, missionId:any){
        this.store.dispatch(MarketActions.claimReward({userId:userId,missionId:missionId}));
    }

    levels(){
        this.store.dispatch(MarketActions.levels({data:null}));
    }

    filterMissions(filters:any, missions:any[], userId:any){
        this.store.dispatch(MarketActions.missionsFilter({missions:missions,filter:filters, userId:userId}));
    }

    setFilter(filters:any){
        this.store.dispatch(MarketActions.setFilter({filter:filters}));
    }

    getInventory(){
        this.store.dispatch(MarketActions.inventory({data:null}));
    }

    getMyInventory(userId:any){
        this.store.dispatch(MarketActions.myinventory({userId:userId}));
    }

    getAllSell(){
        this.store.dispatch(MarketActions.allSell({data:null}));
    }

    purchaseSell(userId:number, userSell:number){
        this.store.dispatch(MarketActions.purchaseSell({userId:userId,userSell:userSell}));
    }

    listSell(userId:number,userItemId:number, price:number){
        this.store.dispatch(MarketActions.listSell({userId:userId, userItemId:userItemId, price:price}));
    }

    cancelSell(userId:number,sell:number){
        this.store.dispatch(MarketActions.cancelSell({userId:userId, sell:sell}));
    }

    purchaseInventory(inventoryId:any, userId:any, quantity:any){
        this.store.dispatch(MarketActions.purchaseInventory({inventoryId: inventoryId,userId:userId, quantity:quantity}));
    }

    getScores(skillId:any, userId:any){
        this.store.dispatch(MarketActions.scoreboard({data:skillId, userId:userId}));
    }

    getShareprofile(modal){
        this.store.dispatch(MarketActions.shareprofile({data:modal}))
    }

    getSeason(){
        this.store.dispatch(MarketActions.getSeasons({data:null}))
    }

    setMyMissionDetails(onMissions, claimable){
        this.store.dispatch(MarketActions.myMissionDetails({onMissions:onMissions, claimable:claimable}))
    }

    selectDetails(deets){
        this.store.dispatch(MarketActions.selectDetails({data:deets}));
    }

    selectPack(deets){
        this.store.dispatch(MarketActions.selectPack({data:deets}));
    }

    burn(userId,ids, season){
        this.store.dispatch(MarketActions.passSignature({userId:userId,ids:ids, season:season}))
    }

    claimReward(userId:any, rewardId:any){
        this.store.dispatch(MarketActions.claimPassReward({userId:userId,rewardId:rewardId}));
    }

    claimSeasonReward(userId:any){
        this.store.dispatch(MarketActions.claimSeasonReward({userId:userId}));
    }

    discordAuth(code:string, userId:any){
        this.store.dispatch(MarketActions.discordData({code:code, userId:userId}))
    }

    packSignature(type:any, userId:any, quantity:any){
        this.store.dispatch(MarketActions.packSignature({userId:userId, typeP:type, quantity:quantity}));
    }

    purchasePack(sig,userId, type, quantity){
        this.store.dispatch(MarketActions.packInteraction({sig:sig, userId:userId, typeP:type, quantity:quantity}));
    }

    packOpen(userId,tokenId, address){
        this.store.dispatch(MarketActions.packOpen({tokenId:tokenId, userId:userId, address:address}));
    }

    upgradeNFT(userId,tokenId, address){
        this.store.dispatch(MarketActions.upgradeNFT({tokenId:tokenId, userId:userId, address:address}));
    }

    closeOpen(){
        this.store.dispatch(MarketActions.closeOpen({data:null}));
    }

    closeUpgrade(){
        this.store.dispatch(MarketActions.closeUpgrade({data:null}));
    }

    packs(userId){
        this.store.dispatch(MarketActions.packs({data:userId}));
    }

    approval(){
        this.store.dispatch(MarketActions.checkApproval({data:null}));
    }

    setLoading(val){
        this.store.dispatch(MarketActions.loadingStart({data:val}));
    }

}